module.exports = __webpack_public_path__ + "img/checkin-icon.89ff6e4b.svg";